import { TARGET_MAP } from '../constants';
import type { ShareFinalTarget, ShareTarget } from '../types';

export const mapShareTarget = (
  shareTarget: ShareTarget,
  openWithShareTo: ShareFinalTarget
): ShareFinalTarget => TARGET_MAP[shareTarget] ?? openWithShareTo;

export const sendMessageToHost = (action: string): void => {
  if (typeof window === 'undefined') return;

  setTimeout(() => {
    window.parent.postMessage(action, window.location.origin);
    window.close();
  }, 300);
};
